<template>
   <div id="pdf-viewer" ref="viewer"></div>
</template>

<style lang="scss">
   #pdf-viewer {
      width: 100vw;
      height: calc( 100vh - 56px );

      & > iframe {
         border: 0;
      }
   }
</style>

<script>
import PDFJSExpress from '@pdftron/pdfjs-express-viewer'

import SETTINGS from '@/plugins/settings'

export default {
   name: 'PdfViewer',

   mixins: [],
   
   components: {},

   data: () => ({

   }),

   props: {
      url:
      {
         type: String,
         required: true
      }
   },

   computed:
   {
      staticPath()
      {
         return `${process.env.BASE_URL}lib`
      }
   },

   methods:
   {
      init()
      {
         /**
          * @see https://pdfjs.express/documentation/get-started-viewer/vue
          */
         PDFJSExpress({
           path: this.staticPath,
           licenseKey: SETTINGS.PDF_VIEWER,
           initialDoc: this.url
         }, this.$refs.viewer )
           .then(instance => {
             
               // at this point, the viewer is 'ready'
               // now you can access APIs through the WebViewer instance
               const { Core } = instance

               instance.UI.setTheme('dark')

               // adding an event listener for when a document is loaded
               Core.documentViewer.addEventListener('documentLoaded', () => {

               })

           })
           .catch(err => {
            console.error(err)
           })

      }
   },

   mounted()
   {
      this.init()
   }
}
</script>